import Vue from '@/setup'

import { CHANNEL_PARTNERDVP, ROUTE_NAME_PERSONS } from '@/config/constants'
import { EVENT_READY } from '@/config/events'

import {
  ApplicationHelper,
  DateTimeHelper,
  SessionHelper,
  DistributionHelper,
  ErrorHelper,
  PartnerHelper,
  BasketHelper,
} from '@/helpers'

const { $EventBus } = Vue.prototype

const language = ApplicationHelper.getLanguage().toUpperCase()

function getNextRoute(to) {
  const nextRoute = {
    name: ROUTE_NAME_PERSONS,
    replace: true,
  }

  if (to.query.cmpID) {
    nextRoute.query = {
      cmpID: to.query.cmpID,
    }
  }

  return nextRoute
}

/**
 * Add all partner routes
 *
 * partner
 * Smile-Direct: #/partner/346448
 *
 * collective-partner
 * FH Schweiz: #/K003910
 * Credit Suisse: #/K003000
 * Siemens Kader: #/K003777
 * Finanzverwaltung Basel Stadt: #/K004070
 */
export default [
  {
    beforeEnter(to, _from, next) {
      const partnerId = to.params.partnerId

      const distributionPartnerPayload = {
        distributionPartnerNumber: partnerId,
        contractStartDate: DateTimeHelper.getDefaultContractStartDate(),
        language,
      }

      return BasketHelper.getAndSetDistributionPartner(distributionPartnerPayload)
        .then(distributionPartnerInfo => {
          const salesPartnerEmail = PartnerHelper.hasSalesPartnerEmail(distributionPartnerInfo.salesPartnerType)
            ? distributionPartnerInfo.email
            : undefined

          return SessionHelper.autostart(
            {
              channel: CHANNEL_PARTNERDVP,
              distributionPartners: DistributionHelper.createDistributionPartners(partnerId),
              language,
              masterTreaty: distributionPartnerInfo.masterTreaty || undefined,
              salesPartnerEmail,
            },
            { startNewSession: true }
          )
        })
        .catch(e => {
          if (e?.response?.status === 404) {
            ApplicationHelper.emitMessages(ErrorHelper.createErrorResponse(e)?.infoMessages)
          }
        })
        .finally(() => {
          next(getNextRoute(to))
          $EventBus.$emit(EVENT_READY)
        })
    },
    meta: {
      disableUnloadConfirmation: true,
      secured: false,
    },
    name: 'partner',
    path: '/partner/:partnerId([0-9]{6})',
  },
  {
    beforeEnter(to, _from, next) {
      return SessionHelper.autostart(
        {
          channel: CHANNEL_PARTNERDVP,
          collective: {
            contractNumber: to.params.contractNumber,
          },
          language,
        },
        { startNewSession: true }
      ).finally(() => {
        next(getNextRoute(to))
        $EventBus.$emit(EVENT_READY)
      })
    },
    meta: {
      disableUnloadConfirmation: true,
      secured: false,
    },
    name: 'collective',
    path: '/:contractNumber(K[0-9]{6})',
  },
]
